import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_UPDATE_SHELF_LABEL_PRINT } from '../updated-article-label-print.api';
import { ShelfLabelPrintRequest } from '../types';

@Injectable()
export class ShelfLabelPrintRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  print(body: ShelfLabelPrintRequest): Promise<void> {
    return this.dataAccess.create(
      { path: SOFTLINE_API_UPDATE_SHELF_LABEL_PRINT },
      body
    );
  }
}
